import React from 'react'
import { Container } from 'react-bootstrap'
import { ExerciseStatus } from '../../../constants/exercises'
import { MmTheme } from '../mmSlice'
import MmGame from './MmGame'
import MmThemeLevelChooser from './MmThemeLevelChooser'
import { getTheme } from '../mmHelper'

export interface IMmInProgressProps {
  status: ExerciseStatus
  currentExercise: number
  themes: MmTheme[]
  cards?: string[]
  selectedTheme?: string
  selectedLevel?: number
  pickThemeAndLevel: (theme: string, level: number) => void
  finishExercise: (attempts: number) => void
}

const MmInProgress = ({
  currentExercise,
  finishExercise,
  pickThemeAndLevel,
  selectedLevel,
  selectedTheme,
  status,
  themes,
  cards,
}: IMmInProgressProps) => {
  if (status !== 'in-progress') { return null }

  const hasLoadedCards = cards && cards.length > 0

  const loadingCards = cards && cards.length === 0

  const theme = getTheme(themes, selectedTheme)

  return (
    <>
      {
        hasLoadedCards && <Container>
          <h4>Exercise {currentExercise}</h4>      
        </Container>
      }
      <MmThemeLevelChooser 
        hidden={hasLoadedCards}
        themes={themes} 
        loadingCards={loadingCards}
        pickThemeAndLevel={pickThemeAndLevel} 
      />
      <MmGame 
        cardBack={theme?.cardBack}
        cards={hasLoadedCards ? cards : undefined}
        gameCompleted={finishExercise}
      />
    </>
  )
}

export default MmInProgress